import { render, staticRenderFns } from "./Unit2.vue?vue&type=template&id=72a6c1a1&"
import script from "./Unit2.vue?vue&type=script&lang=js&"
export * from "./Unit2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports